export default __webpack_public_path__ + "static/kinto-soc-media-d0429c326a9b2b30fc06becc2ec8e76e.jpg";